import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from '../design-system'
import { ArrowLeft, User } from 'lucide-react'

const ProfilePage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-2xl mx-auto text-center">
          <User className="w-16 h-16 mx-auto text-primary-500 mb-4" />
          <h1 className="text-3xl font-bold text-gray-900 mb-8">
            User Profile
          </h1>
          
          <div className="bg-white rounded-lg shadow-sm p-8 mb-8">
            <p className="text-gray-600 mb-4">
              Profile features coming soon. Create an account to track your progress!
            </p>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/test">
              <Button className="w-full sm:w-auto">
                Take Test
              </Button>
            </Link>
            <Link to="/">
              <Button variant="outline" className="w-full sm:w-auto">
                <ArrowLeft className="mr-2 w-4 h-4" />
                Back to Home
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProfilePage